import React from 'react';
import { ShoppingCartIcon } from '@heroicons/react/24/outline';

type Props = {
  className?: string;
  totalCartItems?: number;
  counterClassName?: string;
};

const Icon: React.FC<Props> = ({ className, totalCartItems = 0 }) => (
  <div className="relative">
    {totalCartItems > 0 && (
      <>
        <span className="absolute -right-6 -top-3 size-10 rounded-full bg-green-500" />
      </>
    )}
    <ShoppingCartIcon className={className} stroke="currentColor" />
  </div>
);

export default Icon;
